module.exports = __webpack_public_path__ + "img/L_300_0.f2ac8bdd.png";